import { CompleteWithAILayout } from "v2/components/CompleteWithAI/CompleteWithAILayout";

export const CompleteWithAI = () => {
  return (
    <>
      <title>Complete with AI</title>
      <CompleteWithAILayout />
    </>
  );
};
